export class APIBase {
    /**
     * Generic post data method.
     *
     * @param url string - URL to be called
     * @param data any - data to be submitted
     * @param csrfToken string - CSRF token
     */
    public static async postData(url: string, data: Record<string, unknown>, csrfToken: string) {
        const response = await fetch(url , {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken
            },
            method: 'POST',
            mode: 'same-origin'
        })
        if (response.ok) {
            return response.json()
        } else {
            throw {
                json: await response.json(),
                status: response.status,
                statusText: response.statusText
            }
        }
    }
}
